<template>
  <router-view/>
</template>

<style>
  #app {
    background-color: #f7f8fa;
  }
</style>
